<template>
	<div class="redirect-content">
		<p class="redirect-head"><i class="fa el-icon-tickets" aria-hidden="true"></i> {{ message.redirect_title }}</p>
		<p class="redirect-text-title">
			<span>{{ message.timestamp | messageDateFormat }}</span>
		</p>
		<p class="redirect-text-content">{{ message.redirect_description }}</p>
	</div>
</template>
<script>
export default {
	name: "chat-message-redirect",

	props: {
		message: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="less" scoped>
p {
	margin: 0;
}
.redirect-content {
	width: 200px;
}
.redirect-head {
	font-weight: 600;
	color: black;
	font-size: 16px;
	width: 200px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-bottom: 5px;
	> i {
		font-weight: 500;
		font-size: 16px;
	}
}
.redirect-text-title {
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;

	margin-top: 10px;

	> span {
		color: #404040;
		font-weight: 500;
	}
}
.redirect-text-content {
	margin-top: 10px;
}
</style>
